import axios from 'axios';

export default {
    data() {
        return {
            selectedBloodResult: null,
            dispensingDialog: false,
        };
    },
    computed: {
        dispensingForm() {
            return this.$store.state.patients.dispensingForm;
        },
        maxDaysToDispense() {
            return this.$store.state.patients.dispensingForm.max_allowed_dispensing_days;
        },
        canSendRequest() {
            return (
                typeof this.$store.state.patients.dispensingForm.max_allowed_dispensing_days === 'number' &&
                !!this.selectedBloodResult
            );
        },
    },
    methods: {
        async dispensDay(row) {
            this.updateTableRow(row);
            return await axios
                .post(
                    route('api.v1.patients.dispensing-days.dispensed', {
                        patient: this.selectedBloodResult.patient.id,
                        mode: 'all-blood-results',
                    }),
                    {
                        days: this.dispensingForm.max_allowed_dispensing_days,
                    }
                )
                .then(() => {
                    this.$root.notify(
                        'info',
                        t('default::notification.success'),
                        t('patients::notification.dispensing_days')
                    );
                    this.dispensingDialog = false;
                    this.$store.dispatch('patients/resetDispensingForm', this.selectedBloodResult.patient.id);
                    this.$store.dispatch('patients/resetErrorMessages');
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        error.response.data.errors = error.response.data.errors.map((x) => ({
                            field: 'max_allowed_dispensing_days',
                            errors: x.errors,
                        }));

                        this.$store.dispatch('patients/setErrorMessages', {
                            isDispensingForm: true,
                            errors: error.response.data.errors,
                        });
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                });
        },
        async updateTableRow(row) {
            if (!this.$refs.grid) return;
            return await axios
                .get(route('api.v1.patients.blood-results.show', { patient: row.patient.id, blood_result: row.id }), {
                    params: {
                        fields: 'id,dispensable,next_due_date,validity_date,dispensing_days_suggested,dispensing_days_accumulated',
                    },
                })
                .then((res) => {
                    const row = res.data.data;
                    const items = _.cloneDeep(this.$refs.grid.items);
                    const currentRow = items.findIndex((x) => x.id === row.id);
                    if (currentRow > -1) {
                        items[currentRow] = { ...this.$refs.grid.items[currentRow], ...row };
                        this.$refs.grid.items = items;
                    }
                })
                .catch((error) => this.$root.notify('error', error.response.data.error));
        },
        openDialog(item, modal) {
            this.selectedBloodResult = item;
            switch (modal) {
                case 'assign':
                    this.$store.dispatch('patients/loadBloodResultsPatientOptions', {
                        name: null,
                        pharmacy_site_id: item.pharmacy_site_id,
                    });
                    return (this.patientDialog = true);
                case 'detail':
                    return (this.detailsDialog = true);
                case 'dispensing_days':
                    this.$store.dispatch('patients/updateProperty', {
                        property: 'dispensingForm.max_allowed_dispensing_days',
                        value: item.dispensing_days_suggested,
                    });
                    return (this.dispensingDialog = true);
                default:
                    return;
            }
        },
        close() {
            this.selectedPatient = null;
            this.selectedBloodResult = null;
            this.selectedPatientErrors = [];
        },
    },
};
